import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import Text from '../Text';
import { useState } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { api } from '../../maps/data.js';
import { useEffect } from 'react';
import EdgeCardForSelect from '../EdgeCardForSelect';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';

export default function EdgeDialog(props) {
    const { open, onClose, newEdge, clientId, siteId } = props;
    const [edges, s_edges] = useState([]);
    const [edge, s_edge] = useState(props.edge || {});
    const [floorName, s_floorName] = useState(props.edge?.floorName || '');
    const [edgeIp, s_edgeIp] = useState(props.edge?.edgeIp || '');
    const [addressIp, s_addressIp] = useState(props.edge?.udpAddr || '');
    const [softwareType, s_softwareType] = useState(props.edge?.softwareType || 'FLOOR');
    const [serviceType, s_serviceType] = useState(props.edge?.serviceType || 'EU');

    const save = async () => {
        const data = {
            floorName,
            clientId,
            siteId,
            edgeIp,
            edgeId: edge._id, 
            softwareType,
            serviceType
        };

        if (addressIp) {
            data.udpAddr = addressIp;
        }
        await api({
            type: newEdge ? 'installerAddEdgeToClient' : 'intallerEditClientEdge',
            data: data
        });
        onClose();
    }

    const getEdges = async () => {
        const edges_res = await api({ type: 'getEdges', data: { clientAddEdge: true } });
        s_edges(edges_res);
    }

    useEffect(() => {
        newEdge && getEdges()
    }, []);

    const shouldDisplayEdgeSelect = newEdge && Object.keys(edge).length === 0;

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <ValidatorForm
                onSubmit={save}
                onError={errors => console.log(errors)}>

                <DialogTitle id="alert-dialog-title">
                    {newEdge ? <Tx>edge.add.title</Tx> : <Tx>edge.edit.title</Tx>}
                </DialogTitle>
                <DialogContent style={{ paddingTop: 5 }}>

                    {
                        shouldDisplayEdgeSelect && <>
                            <div><Tx>edge.selectEdge</Tx></div>
                            <div>
                                {
                                    edges.map(edge => <EdgeCardForSelect key={edge._id} edge={edge} onSelect={() => s_edge(edge)} />)
                                }
                            </div>
                        </>
                    }

                    <Text
                        label="edge.edgeNumber"
                        value={edge?.number || ''}
                        disabled={true} />

                    <FormControl fullWidth style={{ marginBottom: 10 }}>
                        <InputLabel id="demo-simple-select-label"><Tx>edge.softwareType</Tx></InputLabel>
                        <Select
                            disabled={!newEdge}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={softwareType}
                            label={<Tx>edge.softwareType</Tx>}
                            onChange={e => {
                                s_softwareType(e.target.value);
                            }}>
                            <MenuItem value={'FLOOR'}>FLOOR</MenuItem>
                            <MenuItem value={'BOX'}>BOX</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth style={{ marginBottom: 10 }}>
                        <InputLabel id="demo-simple3-select-label">Service type</InputLabel>
                        <Select
                            disabled={!newEdge}
                            labelId="demo-simple3-select-label"
                            id="demo3-simple-select"
                            value={serviceType}
                            label="Service type"
                            onChange={e => {
                                s_serviceType(e.target.value);
                            }}>
                            <MenuItem value={'EU'}>EU</MenuItem>
                            <MenuItem value={'FMU'}>FMU</MenuItem>
                        </Select>
                    </FormControl>

                    <Text
                        label="edge.floorName"
                        value={floorName}
                        onChange={s_floorName}
                        validators={['required']}
                        errorMessages={['this field is required']} />
                    <Text
                        label="edge.ipLabel"
                        value={edgeIp}
                        onChange={s_edgeIp}
                        validators={['required']}
                        errorMessages={['this field is required']} />
                    <Text
                        label="edge.udpAddressLable"
                        value={addressIp}
                        onChange={s_addressIp}
                    />

                </DialogContent>

                <DialogActions>

                    <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                    <Button autoFocus type='submit'>
                        <Tx>g.save</Tx>
                    </Button>

                </DialogActions>
            </ValidatorForm>
        </Dialog>)
}